import { useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import { Card } from '../../../layout/Card.jsx';
import { Icon } from '../../../layout/Icon.jsx';
import { Pill } from '../../../layout/Pill.jsx';
import { formatIQD } from '../../../shared/format.js';

function StatusPill({ p }) {
  const cur = Number(p.currentStock || 0);
  const min = Number(p.minStockAlert || 0);
  if (!p.isActive) return <Pill variant="muted">معطّل</Pill>;
  if (cur <= 0) return <Pill variant="danger">نفذ</Pill>;
  if (cur <= min) return <Pill variant="danger">منخفض</Pill>;
  if (cur <= min * 2) return <Pill variant="warning">متوسط</Pill>;
  return <Pill variant="success">جيد</Pill>;
}

export function StockTable({
  products = [],
  loading,
  page,
  pages,
  total,
  onPageChange,
  onAdjust,
  canAdjust
}) {
  const navigate = useNavigate();

  return (
    <Card>
      <div className="overflow-x-auto">
        <table className="w-full text-[13px]">
          <thead className="text-ink-2 text-[12px] sticky top-0 bg-white">
            <tr className="border-b border-line">
              <th className="p-2.5 text-start">المنتج</th>
              <th className="p-2.5 text-start">المخزن</th>
              <th className="p-2.5 text-start">القسم</th>
              <th className="p-2.5 text-start">المخزون</th>
              <th className="p-2.5 text-start">الحد الأدنى</th>
              <th className="p-2.5 text-start">سعر الكلفة</th>
              <th className="p-2.5 text-start">سعر البيع</th>
              <th className="p-2.5 text-start">الحالة</th>
              <th className="p-2.5 text-end">إجراءات</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={9} className="text-center text-ink-3 py-8">جاري التحميل...</td></tr>
            ) : products.length === 0 ? (
              <tr><td colSpan={9} className="text-center text-ink-3 py-10">لا توجد منتجات</td></tr>
            ) : (
              products.map((p, idx) => (
                <tr
                  key={p._id || p.id}
                  className={clsx('border-b border-line hover:bg-paper-2', idx % 2 === 1 && 'bg-paper/40')}
                >
                  <td className="p-2.5">
                    <div className="flex items-center gap-2">
                      <span className="text-[20px]">{p.emoji || '📦'}</span>
                      <div className="min-w-0">
                        <div className="font-bold truncate">{p.name}</div>
                        <div className="text-[11px] text-ink-3" style={{ fontFamily: 'monospace' }}>{p.sku}</div>
                      </div>
                    </div>
                  </td>
                  <td className="p-2.5 text-ink-2">{p.warehouseId?.name || '—'}</td>
                  <td className="p-2.5">
                    {p.categoryId?.name ? <Pill variant="info">{p.categoryId.name}</Pill> : '—'}
                  </td>
                  <td className="p-2.5 font-bold">{p.currentStock ?? 0}</td>
                  <td className="p-2.5 text-ink-2">{p.minStockAlert ?? 0}</td>
                  <td className="p-2.5">{formatIQD(p.costPrice)}</td>
                  <td className="p-2.5 font-bold">{formatIQD(p.salePrice)}</td>
                  <td className="p-2.5"><StatusPill p={p} /></td>
                  <td className="p-2.5">
                    <div className="flex gap-1 justify-end">
                      <button
                        type="button"
                        className="btn"
                        style={{ padding: '4px 8px' }}
                        title="تعديل المنتج"
                        onClick={() => navigate('/products')}
                      >
                        <Icon name="edit" size={13} />
                      </button>
                      {canAdjust ? (
                        <button
                          type="button"
                          className="btn"
                          style={{ padding: '4px 8px' }}
                          title="تسوية"
                          onClick={() => onAdjust(p)}
                        >
                          <Icon name="settings" size={13} />
                        </button>
                      ) : null}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      {pages > 1 ? (
        <div className="card-h border-b-0 border-t flex justify-between items-center text-[12px]">
          <div className="text-ink-3">صفحة {page} من {pages} • {total} منتج</div>
          <div className="flex gap-1">
            <button
              type="button"
              className="btn"
              style={{ padding: '6px 10px' }}
              onClick={() => onPageChange(page - 1)}
              disabled={page <= 1}
            >
              <Icon name="chevronR" size={13} />
            </button>
            <button
              type="button"
              className="btn"
              style={{ padding: '6px 10px' }}
              onClick={() => onPageChange(page + 1)}
              disabled={page >= pages}
            >
              <Icon name="chevronL" size={13} />
            </button>
          </div>
        </div>
      ) : null}
    </Card>
  );
}
